module.exports = __webpack_public_path__ + "media/images/childcare/card-mobile@2x-b238ef872430eac15bd3fcd9c6d43892.jpg";